export function StatusBadge({ value, map }) {
  const cfg = map[value] || { bg: "#F1F5F9", text: "#475569", label: value };
  return (
    <span
      className="badge"
      style={{ backgroundColor: cfg.bg, color: cfg.text }}
      data-testid={`badge-${value}`}
    >
      {cfg.label || value}
    </span>
  );
}

export const leadStatusMap = {
  new: { bg: "#DBEAFE", text: "#1D4ED8", label: "New" },
  contacted: { bg: "#E0E7FF", text: "#4338CA", label: "Contacted" },
  qualified: { bg: "#D1FAE5", text: "#047857", label: "Qualified" },
  unqualified: { bg: "#FEE2E2", text: "#B91C1C", label: "Unqualified" },
  converted: { bg: "#DCFCE7", text: "#166534", label: "Converted" },
};

export const priorityMap = {
  low: { bg: "#F1F5F9", text: "#475569", label: "Low" },
  medium: { bg: "#FEF3C7", text: "#B45309", label: "Medium" },
  high: { bg: "#FEE2E2", text: "#B91C1C", label: "High" },
};

export const dealStageMap = {
  new: { bg: "#DBEAFE", text: "#1D4ED8", label: "New" },
  qualified: { bg: "#E0E7FF", text: "#4338CA", label: "Qualified" },
  site_survey: { bg: "#CFFAFE", text: "#0E7490", label: "Site Survey" },
  proposal: { bg: "#FEF3C7", text: "#B45309", label: "Proposal" },
  negotiation: { bg: "#FFEDD5", text: "#C2410C", label: "Negotiation" },
  won: { bg: "#D1FAE5", text: "#047857", label: "Won" },
  lost: { bg: "#FEE2E2", text: "#B91C1C", label: "Lost" },
};

export const projectStatusMap = {
  planning: { bg: "#DBEAFE", text: "#1D4ED8", label: "Planning" },
  in_progress: { bg: "#FEF3C7", text: "#B45309", label: "In Progress" },
  on_hold: { bg: "#F1F5F9", text: "#475569", label: "On Hold" },
  completed: { bg: "#D1FAE5", text: "#047857", label: "Completed" },
  cancelled: { bg: "#FEE2E2", text: "#B91C1C", label: "Cancelled" },
};

export const invoiceStatusMap = {
  draft: { bg: "#F1F5F9", text: "#475569", label: "Draft" },
  sent: { bg: "#DBEAFE", text: "#1D4ED8", label: "Sent" },
  partially_paid: { bg: "#FEF3C7", text: "#B45309", label: "Partial" },
  paid: { bg: "#D1FAE5", text: "#047857", label: "Paid" },
  overdue: { bg: "#FEE2E2", text: "#B91C1C", label: "Overdue" },
  cancelled: { bg: "#E5E7EB", text: "#374151", label: "Cancelled" },
};

export const poStatusMap = {
  draft: { bg: "#F1F5F9", text: "#475569", label: "Draft" },
  sent: { bg: "#DBEAFE", text: "#1D4ED8", label: "Sent" },
  acknowledged: { bg: "#E0E7FF", text: "#4338CA", label: "Acknowledged" },
  received: { bg: "#D1FAE5", text: "#047857", label: "Received" },
  cancelled: { bg: "#FEE2E2", text: "#B91C1C", label: "Cancelled" },
};
